import * as React from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';
export interface LoaderProps {
  show: boolean;
  message?: string; 
  children?: any;
  noHeight?: boolean;
}

const style = {
  container: {
    position: 'relative',
    textAlign: 'center',
    display:'flex',
    flexFlow: 'column',
    justifyContent:'center',
    alignItems:'center',
  } as React.CSSProperties,
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};
const Loader = (props: LoaderProps) => {
  const { show, children, message = '', noHeight } = props;
  const minHeight = noHeight ? '300px' : '80vh';
  const styles = {...style.container, minHeight };
  return (
    <div>
      {show ? (
        <div style={styles}>
            <div>
            <RefreshIndicator
            size={40}
            left={10}
            top={0}
            status='loading'
            style={style.refresh}
          />
            </div>
          
           <h1>{message}</h1>
        </div>
      ) : (
          children
        )}
    </div>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/common/Loader.tsx